import { initialUser } from '@domain/users/model.ts'
import { User } from '@domain/users/types.ts'
import noop from 'lodash/noop'

export type SignedLoginPayload = {
  signature: string
  message: string
}

export type TokenVerificationPayload = {
  token: string
}

export type AuthToken = {
  token: string
}

export type AuthTokens = {
  access: AuthToken
}

export type AuthData = {
  user: User
  tokens: AuthTokens
}

export type SignatureData = {
  signature: string
  message: string
}

export type AuthContextState = {
  auth: [AuthData, (value: AuthData) => void]
  signatureData: SignatureData
  setSignatureData: (signatureData: SignatureData) => void
  setIsBannedUserModalOpen: (value: boolean) => void
}

export const initialAuthData: AuthData = {
  user: initialUser,
  tokens: {
    access: {
      token: '',
    },
  },
}

export const initialContext: AuthContextState = {
  auth: [initialAuthData, () => undefined],
  signatureData: {
    signature: '',
    message: '',
  },
  setSignatureData: () => undefined,
  setIsBannedUserModalOpen: noop,
}

export const authTokensStorageKey = 'authData'
